import { handleException } from 'clients/exception-handling'
import { loadScript } from 'trackers/helper'

export async function initLinkedInPixel(): Promise<void> {
  const partnerId = import.meta.env.VITE_LINKEDIN_PARTNER_ID
  if (!partnerId) return

  window._linkedin_partner_id = partnerId
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id)

  if (!window.lintrk) {
    window.lintrk = Object.assign(
      (a: string, b: Record<string, unknown>) => {
        window.lintrk!.q.push([a, b])
      },
      { q: [] as [string, Record<string, unknown>][] },
    )
  }
  try {
    await loadScript('https://snap.licdn.com/li.lms-analytics/insight.min.js')
  } catch (error) {
    handleException(error, {
      operation: 'tracker.linkedin.initialize',
      disposition: 'recovered',
      reason: 'Application continues without optional analytics.',
    })
  }
}
